import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import RSVPForm from './components/RSVPForm';
import ShowAllRsvps from './components/ShowAllRsvps';
import ImageCarousel from './components/ImageCarousel';
import LocationDetails from './components/LocationDetails';
import AddToCalendar from './components/AddToCalendar';

function App() {
  const [showAddToCalendar, setShowAddToCalendar] = React.useState(false);

  return (
    <Router>
      <Routes>
        <Route path="/all-rsvps" element={<ShowAllRsvps />} />
        <Route 
          path="/" 
          element={
            <div className="container mx-auto px-4 py-8">
              <div className="text-center mb-8">
                <h1 className="text-2xl font-bold text-sky-800">
                  🚂 Daniel’s 2nd Birthday! 🚂
                </h1>
                <p className="mt-4 text-xl text-gray-700">
                  Sat, Jun 13, 2026 • 10:30AM - 1:00PM
                </p>
                <p className="text-gray-700">
                  Seattle Children’s Museum (Seattle Center)
                </p>
                <LocationDetails />
              </div>

              <div className="mb-8">
                <ImageCarousel imageDirectory="images" />
              </div>
              
              <div className="relative mb-4">
                <div className="absolute inset-0 flex items-center" aria-hidden="true">
                  <div className="w-full border-t border-sky-200"></div>
                </div>
                <div className="relative flex justify-center">
                  <span className="bg-white px-3 text-lg font-medium text-gray-900">
                    Please RSVP Below
                  </span>
                </div>
              </div>

              <RSVPForm onRsvpChange={setShowAddToCalendar} />
              {showAddToCalendar && <AddToCalendar />}
            </div>
          } 
        />
      </Routes>
    </Router>
  );
}

export default App; 